import { createFileRoute } from '@tanstack/react-router';
import { FathomCallbackPage } from '@/containers/integrations/google-callback-page.component';

export const Route = createFileRoute('/integrations/fathom/callback')({
  component: FathomCallbackPage,
});
